import React, { useContext, useEffect } from "react";
import * as css from "./PinModal.module.scss";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../../context/GlobalContextProvider";
import Img from "gatsby-image";
import IconLink from "../../images/icons/link--blue-tilted.svg";

const PinModal = () => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);

  const doCloseByKey = (e: KeyboardEvent) => {
    if (e.key === `Escape`) {
      dispatch({ type: "PIN_MODAL", pinModalContent: null });
    }
  };

  useEffect(() => {
    document.addEventListener(`keydown`, doCloseByKey);

    return () => {
      document.removeEventListener(`keydown`, doCloseByKey);
    };
  }, [doCloseByKey]);

  let theContent = <></>;
  if (state.pinModalContent) {
    if (state.pinModalContent.video) {
      theContent = (
        <iframe
          width={`560`}
          height={`315`}
          src={`https://www.youtube.com/embed/${state.pinModalContent.video}`}
          title={`YouTube video player`}
          frameBorder={`0`}
          allow={`accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture`}
          allowFullScreen
        />
      );
    } else if (state.pinModalContent.hlink || state.pinModalContent.label) {
      theContent = (
        <div className={css.linkBlock}>
          <p>
            {state.pinModalContent.hlink ? (
              <a href={state.pinModalContent.hlink} target={`_blank`}>
                <i>
                  <img src={IconLink} alt="" />
                </i>{" "}
                {state.pinModalContent.label}
              </a>
            ) : (
              <span>{state.pinModalContent.label}</span>
            )}
          </p>
        </div>
      );
    } else {
      theContent = (
        <Img
          fluid={state.pinModalContent.image.childImageSharp.fluid}
          alt={``}
          imgStyle={{ objectFit: "contain" }}
        />
      );
    }
  }

  return (
    <div>
      {state.pinModalContent && (
        <div className={css.base}>
          <div className={css.closeButton}>
            <button
              onClick={() => {
                dispatch({ type: "PIN_MODAL", pinModalContent: null });
              }}
            >
              Close
            </button>
          </div>

          <div className={css.container}>
            <div className={css.content}>{theContent}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PinModal;
